import { CanDeactivateFn } from '@angular/router';
import type { OrderNewPageComponent } from './order-new-page.component';

/** `canDeactivate` of step 1: the page decides — a held booking is asked about («Бронь останется за вами…»), a page with none is left at once. A type-only import: the page stays in its lazy chunk. */
export const canLeaveNewPage: CanDeactivateFn<OrderNewPageComponent> = component => component.canLeave();
